import { Alert } from '@/global/components/Alert'
import Dialog from '@/global/guides/Dialog'
import { Link } from 'global/components/Link'
import { UserRoundPenIcon } from 'lucide-react'

export type FuncionarioAssociado = {
    funcionarioId: number
    nome: string
}

export type ErroAssociacaoFuncionario = {
    funcionarioId: number
    nome?: string
    mensagem: string
}

type Props = {
    associados: FuncionarioAssociado[]
    erros: ErroAssociacaoFuncionario[]
    onClose: () => void
}

export function ErrosAssociacaoModal({ associados, erros, onClose }: Props) {
    return (
        <Dialog.Root open={erros.length > 0} onClose={onClose}>
            <Dialog.Title>Resultado da associação</Dialog.Title>
            <Dialog.Content>
                <div className="flex flex-col gap-3">
                    {associados.map(associado => (
                        <Alert key={associado.funcionarioId} severity="success">
                            {associado.nome}
                        </Alert>
                    ))}
                    {erros.map(erro => (
                        <Alert
                            key={erro.funcionarioId}
                            severity="warning"
                            action={
                                <Link
                                    href={`/cadastros/funcionarios/${erro.funcionarioId}/editar`}
                                    className="flex items-center gap-1 whitespace-nowrap"
                                >
                                    <UserRoundPenIcon size={16} />
                                    Ver cadastro
                                </Link>
                            }
                        >
                            <strong>
                                {erro.nome ??
                                    `Funcionário #${erro.funcionarioId}`}
                            </strong>
                            {' — '}
                            {erro.mensagem}
                        </Alert>
                    ))}
                </div>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
